import { render } from "./tabBar.vue?vue&type=template&id=f855fb1c&scoped=true"
import script from "./tabBar.vue?vue&type=script&lang=js"
export * from "./tabBar.vue?vue&type=script&lang=js"

import "./tabBar.vue?vue&type=style&index=0&id=f855fb1c&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/WJ-WEB/htweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f855fb1c"]])

export default __exports__